import React, { forwardRef, useState } from 'react';
import { TouchableOpacity } from 'react-native';

import { Theme } from '@constants';
import { useContextReference } from '@hooks';

import { TWCSwitch, TWCSwitchProps } from '../../primitives/TWCSwitch/TWCSwitch';

export const FocusableSwitch = forwardRef<TouchableOpacity, FocusableSwitchProps>((properties, reference) => {
  const [focused, setFocused] = useState(false);

  let { color } = properties;

  const {
    backgroundActive,
    backgroundInactive,
    colorFocused,
    testID,
    onBlur = () => {},
    nativeID,
    onFocus = () => {},
    onValueChange = () => {},
    shouldUseContextReference = false,
  } = properties;

  if (focused && colorFocused) {
    color = colorFocused;
    console.log(color, 'COLOR');
  }

  const contextReference = useContextReference<TouchableOpacity>(testID);

  return (
    <TWCSwitch
      {...properties}
      backgroundActive={focused ? Theme.colorFocusText : backgroundActive}
      backgroundInactive={focused ? Theme.colorFocusText : backgroundInactive}
      nativeID={nativeID}
      ref={shouldUseContextReference ? contextReference : reference}
      testID={testID}
      onBlur={event => {
        setFocused(false);
        if (onBlur) {
          onBlur(event);
        }
      }}
      onFocus={event => {
        console.log(`focus: ${nativeID}`);
        setFocused(true);
        if (onFocus) {
          onFocus(event);
        }
      }}
      onKeyDown={event => {
        console.log(event.key, 'onKeyDown');
        if (event.key && event.key === 'Enter' && onValueChange) {
          onValueChange();
        }
      }}
    />
  );
});

type FocusableSwitchProps = TWCSwitchProps & {
  backgroundActive?: string;
  backgroundInactive?: string;
  colorFocused?: string;
  nativeID?: string;
  color?: string;
  shouldUseContextReference?: boolean;
};
